export const normalizeNotificationTagIds = value => {
  if (!Array.isArray(value)) { return []; }

  return [...new Set(
    value
      .map(entry => String(entry ?? "").trim())
      .filter(Boolean)
  )];
};
